import { useState } from "react";

const footerLinks = [
  { label: "今日更新", href: "#updates" },
  { label: "热门追更", href: "#ranking" },
  { label: "分类浏览", href: "#genres" },
  { label: "追更提醒", href: "#feature" },
  { label: "用户口碑", href: "#reputation" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  const [year] = useState(new Date().getFullYear());
  return (
    <footer className="w-full bg-background-200 pt-12 pb-6">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <a href="#home" className="flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg">韩</span>
              <span className="font-heading text-lg text-foreground-900">韩国漫画yy</span>
            </a>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              专注韩漫yy每日更新与追更提醒，热门韩漫连载第一时间同步，不错过任何更新，追更体验更流畅。
            </p>
            <div className="mt-4 flex gap-2">
              {["ri-wechat-line", "ri-qq-line", "ri-bilibili-line", "ri-mail-line"].map((icon) => (
                <a
                  key={icon}
                  href="#subscribe"
                  aria-label="社交媒体入口"
                  className="w-9 h-9 rounded-md bg-background-100 text-foreground-700 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:justify-self-center">
            <h3 className="text-sm font-medium text-foreground-900">站内导航</h3>
            <div className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2">
              {footerLinks.map((l) => (
                <a key={l.href} href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:justify-self-end">
            <h3 className="text-sm font-medium text-foreground-900">追更提醒</h3>
            <p className="mt-3 text-sm text-foreground-600">订阅后每日更新与追更提醒第一时间送达</p>
            <a
              href="#subscribe"
              className="mt-4 inline-flex items-center whitespace-nowrap rounded-md bg-accent-500 text-background-50 px-5 py-2.5 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer"
            >
              <i className="ri-notification-3-line mr-1.5"></i>开启追更提醒
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            © {year} 韩国漫画yy · 专注韩漫每日更新与追更提醒
          </p>
          <a href="#home" className="text-xs text-foreground-500 hover:text-primary-600 inline-flex items-center gap-1 cursor-pointer">
            返回顶部 <i className="ri-arrow-up-line"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}